import { merge } from 'lodash';
import colors from '@/themes/colors/colors';
import { darkenColor, lightenColor } from '@/themes/colorUtils/colorUtils';
import darkTheme from '@/themes/themes/darkTheme';

const drakkullahTheme = {
  name: 'drakkulah',
  primary: {
    textAltColor: lightenColor(colors.crimson, 0.55),
  },
  accent: {
    bg: colors.crimson,
    variant: {
      bg: lightenColor(colors.crimson, 0.1),
    },
  },
  accentComplementary: {
    bg: darkenColor(colors.crimson, 0.35),
    textAltColor: colors.white,
    variant: {
      bg: darkenColor(colors.crimson, 0.25),
    },
  },
  input: {
    active: {
      bg: '#4c2928',
      border: lightenColor(colors.crimson, 0.3),
    },
  },

};

export default Object.freeze(merge({}, darkTheme, drakkullahTheme));
